import React from 'react';

import Footer from '../Footer/Footer';
import SignUpPopup from '../Form/SignUp/Popup';
import Header from '../Header/Header';
import RenderOnVisible from '../RenderOnVisible';

import { INavigationItem } from './Navigation';

import '../../styles/global.scss';

import { graphql, StaticQuery } from 'gatsby';
import { Helmet } from 'react-helmet';
import mediumFont from 'static/fonts/graphik/Graphik-Medium-Web.woff2';
import regularFont from 'static/fonts/graphik/Graphik-Regular-Web.woff2';
import semiboldFont from 'static/fonts/graphik/Graphik-Semibold-Web.woff2';

interface ILayoutData {
  file: any;
  allGhostSettings: any;
}

interface ILayoutDataProp {
  data: ILayoutData;
}

export interface ISiteSettings {
  title: string;
  navigation: INavigationItem[];
}

export interface IDefaultLayoutProps {
  children: any;
  mainClass?: string;
  isHome?: boolean;
  postTitle?: string;
  headerClassName?: string;
  isLightTheme?: boolean;
  isDarkTheme?: boolean;
  isArticle?: boolean;
}

interface IDefaultLayoutFullProps extends IDefaultLayoutProps, ILayoutDataProp {}

/**
 * Main layout component
 *
 * The Layout component wraps around each page and template.
 * It also provides the header, footer as well as the main
 * styles, and meta data for each page.
 *
 */
const DefaultLayout = ({
  data,
  children,
  mainClass,
  postTitle,
  headerClassName,
  isLightTheme,
  isDarkTheme,
  isArticle,
}: IDefaultLayoutFullProps) => {
  const site = data.allGhostSettings.edges[0].node;

  return (
    <>
      <SignUpPopup />
      <Helmet>
        <html lang={site.lang} />
        <style type="text/css">{`${site.codeinjection_styles}`}</style>
        <link rel="prefetch" href={regularFont} as="font"></link>
        <link rel="prefetch" href={mediumFont} as="font"></link>
        <link rel="prefetch" href={semiboldFont} as="font"></link>

        <link rel="preconnect" crossOrigin="" href="https://analytics.twitter.com" />
        <link rel="preconnect" crossOrigin="" href="https://t.co" />
        <link rel="preconnect" crossOrigin="" href="https://stats.g.doubleclick.net" />
        <link rel="preconnect" crossOrigin="" href="https://www.google.com" />
        <link rel="preconnect" crossOrigin="" href="https://www.facebook.com" />
        <link rel="preconnect" crossOrigin="" href="https://ct.pinterest.com" />
        <link rel="preconnect" crossOrigin="" href="https://clientcdn.pushengage.com" />
        <link rel="preconnect" crossOrigin="" href="https://connect.facebook.net" />
        <link rel="preconnect" crossOrigin="" href="https://www.google-analytics.com" />
        <link rel="preconnect" crossOrigin="" href="https://static.ads-twitter.com" />
        <link rel="preconnect" crossOrigin="" href="https://s.pinimg.com" />
        <link rel="preconnect" crossOrigin="" href="http://t.co" />

        {/* using dns-prefetch as a fallback for browsers that do not support preconnect. */}

        <link rel="dns-prefetch" crossOrigin="" href="https://analytics.twitter.com" />
        <link rel="dns-prefetch" crossOrigin="" href="https://t.co" />
        <link rel="dns-prefetch" crossOrigin="" href="https://stats.g.doubleclick.net" />
        <link rel="dns-prefetch" crossOrigin="" href="https://www.google.com" />
        <link rel="dns-prefetch" crossOrigin="" href="https://www.facebook.com" />
        <link rel="dns-prefetch" crossOrigin="" href="https://ct.pinterest.com" />
        <link rel="dns-prefetch" crossOrigin="" href="https://clientcdn.pushengage.com" />
        <link rel="dns-prefetch" crossOrigin="" href="https://connect.facebook.net" />
        <link rel="dns-prefetch" crossOrigin="" href="https://www.google-analytics.com" />
        <link rel="dns-prefetch" crossOrigin="" href="https://static.ads-twitter.com" />
        <link rel="dns-prefetch" crossOrigin="" href="https://s.pinimg.com" />
        <link rel="dns-prefetch" crossOrigin="" href="http://t.co" />
      </Helmet>
      <Header
        site={site}
        postTitle={postTitle}
        className={headerClassName}
        isLightTheme={isLightTheme}
        isDarkTheme={isDarkTheme}
        isProgressShown={isArticle}
      />
      <main className={mainClass}>{children}</main>
      <RenderOnVisible>
        <Footer site={site} />
      </RenderOnVisible>
    </>
  );
};

const DefaultLayoutSettingsQuery = (props: IDefaultLayoutProps) => {
  const renderDefaultLayoutSettings = (data: ILayoutData) => (
    <DefaultLayout data={data} {...props} />
  );
  return (
    <StaticQuery
      query={graphql`
        query GhostSettings {
          allGhostSettings {
            edges {
              node {
                ...GhostSettingsFields
              }
            }
          }
          file(relativePath: { eq: "ghost-icon.png" }) {
            childImageSharp {
              fixed(width: 30, height: 30) {
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
      `}
      render={renderDefaultLayoutSettings}
    />
  );
};

export default DefaultLayoutSettingsQuery;
